<template>
  <div>
    <div class="w100" v-if="siftData.length > 0">
      <SiftComp ref="sift" :sift-data="siftData" :loading="loading" @click-search="fetchData" />
    </div>

    <div class="w100 pb20 cl-f">
      <div class="fr pr10">
        <el-button v-if="appData" @click="$emit('click-collect', appData.isCollect)" :loading="collecting">
          <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
        </el-button>
        <el-button v-if="siftData.length > 0" type="primary" :loading="loading" @click="fetchData()">查询</el-button>
      </div>
    </div>

    <section v-if="error == 0 && labelData.length > 0">
      <el-table class="w100 tx-c my-table" :data="listData" stripe border height="460" @row-click="clickRow">
        <el-table-column v-for="(item, index) in labelData" :key="index" :label="item.label" v-show="item.key != 'id'" resizable align="center">
          <template slot-scope="scope">
            <span>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "StudentPunishment",
  components: {
    SiftComp
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {

      loading: false,
      error: "",

      siftData: [],
      labelData: [],

      listData: [],
      page: 1,
      size: 30,
      total: 0
    };
  },
  computed: {
    ...mapState(["userData", "userToken"])
  },
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  methods: {
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post(
          this.$route.query.interfaceUrl + `/getTitleData`,
          this.$qs.stringify({
            userId: this.userData.userId,
            id: this.$route.query.id
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            if (data.resData.siftData) {
              this.siftData = data.resData.siftData;
            }
            if (data.resData.labelData) {
              this.labelData = data.resData.labelData;
            }
            this.$nextTick(() => {
              this.fetchData();
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    fetchData() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      obj.userId = this.userData.userId;
      obj.pageNum = this.page;
      obj.pageSize = this.size;
      // console.log(obj);

      this.loading = true;
      this.$http
        .post(
          this.$route.query.interfaceUrl + `/query`,
          this.$qs.stringify(obj)
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            this.total = data.resData.total;
            this.listData = data.resData.list;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          // this.error = 404;
          this.loading = false;
        });
    },
    download() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      let str = "?";
      str += "xn=" + obj.xn;
      str += "&xq=" + obj.xq;
      str += "&nj=" + obj.nj;
      str += "&yx=" + obj.yx;
      str += "&zy=" + obj.zy;
      str += "&bj=" + obj.bj;
      str += "&hm=" + obj.hm;
      str += "&xslb=" + obj.xslb;
      str += "&sfzj=" + obj.sfzj;
      str += "&sfzx=" + obj.sfzx;
      str += "&wjlx=" + obj.wjlx;
      str += "&cfzl=" + obj.cfzl;
      str += "&cfwh=" + obj.cfwh;
      str += "&cfrq_st=" + obj.cfrq_st;
      str += "&cfrq_ed=" + obj.cfrq_ed;
      str += "&ckq=" + obj.ckq;
      str += "&cfzt=" + obj.cfzt;
      str += "&dqzt=" + obj.dqzt;
      str += "&token=" + this.userToken;
      // console.log(str);

      this.$http
        .get("studentPunishment/exportData" + str, {
          responseType: "blob"
        })
        .then(({ data }) => {
          // console.log(data);
          if (!data) {
            return;
          }
          let url = window.URL.createObjectURL(data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "excel.xls");
          document.body.appendChild(link);
          link.click();
          // console.log(link);
          // window.location.href = link;
          return;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
        });
    },
    clickRow(row, event, column) {
      console.log(row);
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>
